// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3-JKw","errors":"Errors_errors__1STEJ"};